import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

/**
 * Pushes a virtual page_view event to the GTM dataLayer on every
 * React Router navigation, so GA4 captures SPA route changes.
 *
 * In GTM, create a Trigger of type "Custom Event" with event name `page_view`
 * if you want a dedicated GA4 event tag — otherwise the default Google Tag
 * already listens to history changes via Enhanced Measurement.
 */
export function RouteChangeTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    const url = location.pathname + location.search;
    window.dataLayer.push({
      event: "page_view",
      page_path: url,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
